module.exports = __webpack_public_path__ + "static/media/concierge@3x.8caba4c5.png";